import Cookies from "js-cookie";

export const setItem = (key: string, value: string) => {
  Cookies.set(key, value);
}

export const getItem = (key: string) => {
  return Cookies.get(key);
}

export const availabelStatus = [
  {
    label: 'Pending approval',
    value: 'VALIDATION_PENDING'
  },
  {
    label: 'Active',
    value: 'ACTIVE'
  },
  {
    label: 'Declined',
    value: 'DECLINED'
  },
  {
    label: 'Disabled',
    value: 'ARCHIVED'
  },
  {
    label: 'Expired',
    value: 'EXPIRED'
  },
  {
    label: 'Onboarded',
    value: 'ONBOARDED'
  }
];

export const YesOrNoDropdownOptions = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

export const STORAGE = {
  SSO_USER_DOWNLOADED: 'sso-user-downloaded',
};

export const QUEUE_POSITION_CHECK_INTERVAL = 60000 * 2; // 60000 = 1 minute

export const PRIVACY_POLICY_URL = {
  TERMS_OF_USE: "TERMS_OF_USE",
  PRIVACY_POLICY: "PRIVACY_POLICY",
  SALES_AGREEMENT: "SALES_AGREEMENT"
};